import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { useLocation } from "react-router-dom";
import {
  getPlayerBetHistory,
  getBetUserData,
  setPaginationFirstValue,
  setPaginationSecondValue,
  setRecordsShow,
  setIsvisible,
  setBetStatusFilter,
  setBetDecisionStatusFilter,
} from "./playerBetHistorySlice";
import BettingHistoryTable from "./bettingHistoryTable";
import {
  formatMoney,
  getDateTimeFormate,
  Currency,
  getIsOssino,
  convertToUSD,
  getConvertedAmountWithCurrency,
} from "../../sharedfiles/helper";
import { exportPDFC } from "../../sharedfiles/pdfExport";
import Vpagination from "../../sharedfiles/Vpagination";
import Skelton from "../Common/skeleton/Skeleton";
import { BETHISTORY_CONSTANTS, COMMON_CONSTANTS } from "../../sharedfiles/Constants";
import ButtonGroup from "../Common/Buttons/ButtonGroup";
import Tooltips from "../Common/Tooltip";
import { Betting } from "../../sharedfiles/tooltipMsgs";
import { BetStatus, betDecisionStatusOptions } from "../Common/data/BettingHistory/BettinghistoryData";
import MultipleSelectDDL from "../Common/inputs/MultiSelectDropdown";
import Select from "../Common/inputs/SelectDropdown";
const BettingHistory = (props) => {
  const [betStatus, setBetStatus] = useState(props.betStatusFilter || "");
  const [betDecisionStatus, setBetDecisionStatus] = useState(props.betDecisionStatusFilter || "");
  const [errorMsg, setErrorMsg] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const [payload, setPayload] = useState({});
  const [userId, setUserId] = useState(
    props.userId ? props.userId : localStorage.getItem("userId")
  );
  const [shouldReset, setShouldReset] = useState(false);
  const showPermission = props.stakeTaxPermit && props.winTaxPermit;
  const callApi = (pageNumber, itemsPerPage, silent = false) => {
    // dispatch(
    //   getBetUserData(pageNumber - 1, props.paginationSecondValue, {
    //     id: localStorage.getItem("userId"),
    //   })
    // );
    if (!silent) {
      dispatch(setIsvisible(false));
    }
    dispatch(
      getPlayerBetHistory(pageNumber - 1, itemsPerPage, {
        betStatus: betStatus,
        userId: userId,
        betDecisionStatus: betDecisionStatus,
      })
    );
    // recordsShow(pageNumber, props.paginationSecondValue);
  };

  const isOssino = getIsOssino();

  const headers = [
    [
      "Bet ID",
      "Booking Code",
      "Short Bet ID",
      "Event Name",
      "Bet Status",
      "Bet Decision Status",
      "Bet Decision Reviewer Name",
      "Bet Decision Reason",
      "Rejection Code",
      "Placed On",
      "Settled On",
      "Bet fold",
      "Bet Type",
      `Stake ${Currency()}`,
      ...(isOssino ? ["Stake (USD)"] : []),
      `Payout ${Currency()}`,
      ...(isOssino ? ["Payout (USD)"] : []),
      `Potential Payout ${Currency()}`,
      ...(isOssino ? ["Potential Payout (USD)"] : []),
      showPermission ? `Stake Tax ${Currency()}` : null,
      showPermission ? `Stake After Tax ${Currency()}` : null,
      ...(isOssino ? ["Stake After Tax (USD)"] : []),
      showPermission ? `Stake Tax Amount ${Currency()}` : null,
      ...(isOssino ? ["Stake Tax Amount (USD)"] : []),
      showPermission ? `Winnings Tax ${Currency()}` : null,
      showPermission ? `Winnings Tax Amount ${Currency()}` : null,
      ...(isOssino ? ["Winnings Tax Amount (USD)"] : []),
      "Total Payout ${Currency()}",
      ...(isOssino ? ["Total Payout (USD)"] : []),
      "Total Payout With Bonus ${Currency()}",
      ...(isOssino ? ["Total Payout With Bonus (USD)"] : []),
      "Bonus Max Win Amount ${Currency()}",
      ...(isOssino ? ["Bonus Max Win Amount (USD)"] : []),
      "Bonus Max Win Percentage",
      "Place Bet Type",
    ],
  ].filter(Boolean);

  const data =
    props.playerBetHistoryData &&
    Object.keys(props.playerBetHistoryData).length > 0 &&
    props.playerBetHistoryData?.data &&
    Array.isArray(props.playerBetHistoryData?.data) &&
    props.playerBetHistoryData.data.map((item) => [
      item.betId,
      item.bookingCode,
      item.shortBetId,
      item.fixtureName,
      item.betStatus,
      item.betDecisionStatus || "-",
      item.betDecisionReviewerName || "-",
      item.betDecisionReason || "-",
      item.rejectionCode,
      item.placedDate ? getDateTimeFormate(item.placedDate) : "-",
      item.settledDate ? getDateTimeFormate(item.settledDate) : "-",
      // item.bets && item.bets.length,
      item.betFold,
      item.betType,
      getConvertedAmountWithCurrency(item.stake, item.currencyCode || item.currency, item.baseCurrencyRate),
      ...(isOssino
        ? [
          item.baseCurrencyRate === null ||
            item.baseCurrencyRate === undefined
            ? "-"
            : formatMoney(
              convertToUSD(item.stake, item.baseCurrencyRate, "USD")
            ),
        ]
        : []),
      getConvertedAmountWithCurrency(item.payout, item.currencyCode || item.currency, item.baseCurrencyRate),
      ...(isOssino
        ? [
          item.baseCurrencyRate === null ||
            item.baseCurrencyRate === undefined
            ? "-"
            : formatMoney(
              convertToUSD(item.payout, item.baseCurrencyRate, "USD")
            ),
        ]
        : []),
      getConvertedAmountWithCurrency(item.potentialPayout, item.currencyCode || item.currency, item.baseCurrencyRate),
      ...(isOssino
        ? [
          item.baseCurrencyRate === null ||
            item.baseCurrencyRate === undefined
            ? "-"
            : formatMoney(
              convertToUSD(
                item.potentialPayout,
                item.baseCurrencyRate,
                "USD"
              )
            ),
        ]
        : []),
      showPermission ? item.stakeTax : "",
      showPermission ? getConvertedAmountWithCurrency(item.stakeAfterTax, item.currencyCode || item.currency, item.baseCurrencyRate) : "",
      ...(isOssino
        ? [
          item.baseCurrencyRate === null ||
            item.baseCurrencyRate === undefined
            ? "-"
            : formatMoney(
              convertToUSD(item.stakeAfterTax, item.baseCurrencyRate, "USD")
            ),
        ]
        : []),
      showPermission ? getConvertedAmountWithCurrency(item.stakeTaxAmount, item.currencyCode || item.currency, item.baseCurrencyRate) : "",
      ...(isOssino
        ? [
          item.baseCurrencyRate === null ||
            item.baseCurrencyRate === undefined
            ? "-"
            : formatMoney(
              convertToUSD(
                item.stakeTaxAmount,
                item.baseCurrencyRate,
                "USD"
              )
            ),
        ]
        : []),
      showPermission ? item.winningsTax : "",
      showPermission ? getConvertedAmountWithCurrency(item.winningsTaxAmount, item.currencyCode || item.currency, item.baseCurrencyRate) : "",
      ...(isOssino
        ? [
          item.baseCurrencyRate === null ||
            item.baseCurrencyRate === undefined
            ? "-"
            : formatMoney(
              convertToUSD(
                item.winningsTaxAmount,
                item.baseCurrencyRate,
                "USD"
              )
            ),
        ]
        : []),
      getConvertedAmountWithCurrency(item.totalPayout, item.currencyCode || item.currency, item.baseCurrencyRate),
      ...(isOssino
        ? [
          item.baseCurrencyRate === null ||
            item.baseCurrencyRate === undefined
            ? "-"
            : formatMoney(
              convertToUSD(item.totalPayout, item.baseCurrencyRate, "USD")
            ),
        ]
        : []),
      getConvertedAmountWithCurrency(item.totalPayoutWithBonus, item.currencyCode || item.currency, item.baseCurrencyRate),
      ...(isOssino
        ? [
          item.baseCurrencyRate === null ||
            item.baseCurrencyRate === undefined
            ? "-"
            : formatMoney(
              convertToUSD(
                item.totalPayoutWithBonus,
                item.baseCurrencyRate,
                "USD"
              )
            ),
        ]
        : []),
      getConvertedAmountWithCurrency(item.bonusMaxWinAmount, item.currencyCode || item.currency, item.baseCurrencyRate),
      ...(isOssino
        ? [
          item.baseCurrencyRate === null ||
            item.baseCurrencyRate === undefined
            ? "-"
            : formatMoney(
              convertToUSD(
                item.bonusMaxWinPercentage,
                item.baseCurrencyRate,
                "USD"
              )
            ),
        ]
        : []),
      item.bonusMaxWinPercentage,
      item.placeBetType,
    ]);
  const csvData =
    Object.keys(props.playerBetHistoryData).length > 0
      ? [headers[0], ...data]
      : [headers[0], []];

  const exportPDF = () => {
    const title = "Player Bet History Report";

    const styles = {
      6: {
        halign: "right",
        valign: "middle",
      },
      7: {
        halign: "right",
        valign: "middle",
      },
      4: {
        halign: "right",
        valign: "middle",
      },
    };

    exportPDFC(title, headers, data);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const paylaod = {
      betStatus: betStatus,
      userId: userId,
      betDecisionStatus: betDecisionStatus,
    };
    setPayload(paylaod);
    if (betStatus !== "" || betDecisionStatus !== "") {
      dispatch(setIsvisible(false));
      if (props.paginationFirstValue == 1) {
        callApi(
          props.paginationFirstValue,
          props.paginationSecondValue,
          paylaod
        );
        props.dispatch(setPaginationFirstValue(1));
        props.dispatch(setPaginationSecondValue(25));
        props.dispatch(setRecordsShow([1, 25]));
      }
      if (props.paginationFirstValue > 1) {
        resetCalls(paylaod);
      }
      // setBetStatus("");
    }
  };

  const onKeyUp = (event) => {
    if (event.charCode === 13) {
      onSubmit(event);
    }
  };
  const emptyState = () => {
    setBetStatus("");
    dispatch(setBetStatusFilter(""));
    setBetDecisionStatus("");
    dispatch(setBetDecisionStatusFilter(""));
    setShouldReset(true);
  };
  const resetCalls = (paylaod) => {
    dispatch(setPaginationFirstValue(1));
    dispatch(setPaginationSecondValue(25));
    dispatch(setIsvisible(false));
    dispatch(getPlayerBetHistory(0, 25, paylaod));
    dispatch(setRecordsShow([1, 25]));
  };

  const resetButton = () => {
    emptyState();
    resetCalls({ userId: userId });
    // setUserId(localStorage.getItem("userId"));
  };
  const mountingCall = (id) => {
    dispatch(getBetUserData(id));
    dispatch(getPlayerBetHistory(0, 25, { userId: id }));
  };

  useEffect(() => {
    let mounting = true;

    if (mounting) {
      const userId = location.pathname.split("/")[2];
      if (props.userId !== userId) {
        mountingCall(userId);
      }
    }

    return () => (mounting = false);
  }, [location]);

  useEffect(() => {
    const id = window.location.pathname.split("/")[2];
    let mounting = true;

    if (mounting) {
      const paylaod = {
        betStatus: betStatus,
        userId: userId,
        betDecisionStatus: betDecisionStatus,
      };
      setPayload(paylaod);
      dispatch(getBetUserData(id));
      const dataExist =
        props.playerBetHistoryData &&
        Object.keys(props.playerBetHistoryData).length > 0;
      // Data from a previous load already lives in redux (e.g. switching back
      // to this tab) - refresh it in the background instead of flashing the
      // loader over it.
      callApi(1, 25, dataExist);
    }
    return () => (mounting = false);
  }, []);

  const userStats = Array.isArray(props.userData)
    ? props.userData[0]
    : props.userData;

  const formatStatAmount = (amount, currencyCode, baseCurrencyRate) => {
    const converted = getConvertedAmountWithCurrency(amount, currencyCode, baseCurrencyRate);
    return typeof converted === "number"
      ? converted.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      : converted;
  };

  const netPosition =
    (userStats?.settledStakes || 0) - (userStats?.settledPayout || 0);

  const handleSelectedValues = (selected) => {
    const normalized = Array.isArray(selected) ? selected : []
    setBetStatus(normalized || [])
    dispatch(setBetStatusFilter(normalized || []))
    setShouldReset(false)
  }

  const handleBetDecisionStatusChange = (e) => {
    setBetDecisionStatus(e.target.value)
    dispatch(setBetDecisionStatusFilter(e.target.value))
  }
  return (
    <>
      <div className='space-y-6' id='CMS-bettingHistory'>
        {props.errorMessage != "" && props.playerBetHistoryData < 0 ? (
          <div className='flex flex-col items-center justify-center py-8'>
            <div className='text-muted-foreground text-base'>{props.errorMessage}</div>
          </div>
        ) : (
          ""
        )}

        {/* Stats Card */}
        <div className='rounded-lg border bg-card shadow-sm'>
          <div className="p-6 border-b">
            <h3 className='text-lg font-semibold text-foreground'>Betting Statistics</h3>
            <p className='text-sm text-muted-foreground mt-1'>Overview of player betting activity</p>
          </div>

          <div className='p-6'>
            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6'>
              {/* Unsettled Stats Card */}
              <div className='rounded-lg border bg-gradient-to-br from-amber-50/50 to-amber-100/30 dark:from-amber-950/20 dark:to-amber-900/10 border-amber-200 dark:border-amber-800 p-4 space-y-3'>
                <div className="flex items-center gap-2 mb-2">
                  <div className="h-2 w-2 rounded-full bg-amber-500"></div>
                  <h4 className='text-sm font-semibold text-foreground'>Unsettled Bets</h4>
                </div>
                <div className='space-y-2.5'>
                  <div className='flex items-center justify-between p-2 rounded bg-background/50'>
                    <span className='text-xs font-medium text-muted-foreground'>{BETHISTORY_CONSTANTS.header_unsettledBetCount}</span>
                    <span className='text-sm font-bold text-amber-700 dark:text-amber-400'>{userStats?.unSettledBetCount ? userStats?.unSettledBetCount : 0}</span>
                  </div>
                  <div className='flex items-center justify-between p-2 rounded bg-background/50'>
                    <span className='text-xs font-medium text-muted-foreground'>{BETHISTORY_CONSTANTS.header_unsettledStake}</span>
                    <span className='text-sm font-bold text-amber-700 dark:text-amber-400'>{Currency()} {formatStatAmount(userStats?.unSettledStakes || 0, userStats?.currencyCode, userStats?.baseCurrencyRate)}</span>
                  </div>
                  <div className='flex items-center justify-between p-2 rounded bg-background/50'>
                    <span className='text-xs font-medium text-muted-foreground'>{BETHISTORY_CONSTANTS.header_unsetleMaxPayout}</span>
                    <span className='text-sm font-bold text-amber-700 dark:text-amber-400'>{Currency()} {formatStatAmount(userStats?.unSettledPayout || 0, userStats?.currencyCode, userStats?.baseCurrencyRate)}</span>
                  </div>
                </div>
              </div>

              {/* Settled Stats Card */}
              <div className='rounded-lg border bg-gradient-to-br from-green-50/50 to-green-100/30 dark:from-green-950/20 dark:to-green-900/10 border-green-200 dark:border-green-800 p-4 space-y-3'>
                <div className="flex items-center gap-2 mb-2">
                  <div className="h-2 w-2 rounded-full bg-green-500"></div>
                  <h4 className='text-sm font-semibold text-foreground'>Settled Bets</h4>
                </div>
                <div className='space-y-2.5'>
                  <div className='flex items-center justify-between p-2 rounded bg-background/50'>
                    <span className='text-xs font-medium text-muted-foreground'>{BETHISTORY_CONSTANTS.header_settleBetCount}</span>
                    <span className='text-sm font-bold text-green-700 dark:text-green-400'>{userStats?.settledBetCount ? userStats?.settledBetCount : 0}</span>
                  </div>
                  <div className='flex items-center justify-between p-2 rounded bg-background/50'>
                    <span className='text-xs font-medium text-muted-foreground'>{BETHISTORY_CONSTANTS.header_settleStake}</span>
                    <span className='text-sm font-bold text-green-700 dark:text-green-400'>{Currency()} {formatStatAmount(userStats?.settledStakes || 0, userStats?.currencyCode, userStats?.baseCurrencyRate)}</span>
                  </div>
                  <div className='flex items-center justify-between p-2 rounded bg-background/50'>
                    <span className='text-xs font-medium text-muted-foreground'>{BETHISTORY_CONSTANTS.header_settlePayout}</span>
                    <span className='text-sm font-bold text-green-700 dark:text-green-400'>{Currency()} {formatStatAmount(userStats?.settledPayout || 0, userStats?.currencyCode, userStats?.baseCurrencyRate)}</span>
                  </div>
                </div>
              </div>

              {/* Net Position & Filter Card */}
              <div className='rounded-lg border bg-gradient-to-br from-blue-50/50 to-blue-100/30 dark:from-blue-950/20 dark:to-blue-900/10 border-blue-200 dark:border-blue-800 p-4 space-y-3'>
                <div className="flex items-center gap-2 mb-2">
                  <div className="h-2 w-2 rounded-full bg-blue-500"></div>
                  <h4 className='text-sm font-semibold text-foreground'>Summary</h4>
                </div>
                <div className='space-y-2'>
                  <div className='px-3 py-1.5 rounded-lg bg-background border border-border'>
                    <div className='flex items-center justify-between'>
                      <span className='text-xs font-medium text-muted-foreground'>{BETHISTORY_CONSTANTS.header_settleNetPosition}</span>
                      <span className={`text-lg font-bold ${netPosition >= 0 ? 'text-green-600 dark:text-green-400' : 'text-red-600 dark:text-red-400'}`}>
                        {Currency()} {formatStatAmount(netPosition || 0, userStats?.currencyCode, userStats?.baseCurrencyRate)}
                      </span>
                    </div>
                  </div>
                  <div>
                    <div className='flex items-center gap-2 mb-1'>
                      <span className='text-xs font-semibold text-foreground'>{BETHISTORY_CONSTANTS.header_betStatus}</span>
                      <Tooltips info={Betting.Bet_Status} />
                    </div>
                    <MultipleSelectDDL
                      options={BetStatus}
                      onSelect={(value) => handleSelectedValues(value)}
                      shouldReset={shouldReset}
                      initialSelected={betStatus ? betStatus.filter(Boolean) : []}
                      size="sm"
                    />
                  </div>
                  <div>
                    <div className='flex items-center gap-2 mb-1'>
                      <span className='text-xs font-semibold text-foreground'>Bet Decision Status</span>
                      <Tooltips info={"Filter bets by the reviewer's decision status"} />
                    </div>
                    <Select
                      name={"betDecisionStatus"}
                      ids={"betDecisionStatus"}
                      value={betDecisionStatus}
                      setValue={(e) => handleBetDecisionStatusChange(e)}
                      options={betDecisionStatusOptions}
                      size="sm"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Action Buttons */}
            <div className='pt-6 mt-6 border-t bg-muted -mx-6 -mb-6 px-6 pb-6'>
              <ButtonGroup
                groupNames={["Search", "Reset"]}
                idsearch={"bethistorybtn"}
                idreset={"bethistoryreset"}
                submit={(e) => onSubmit(e)}
                reset={() => resetButton()}
              />
            </div>
          </div>

          {/* Results Section */}
          <div className='p-6 space-y-4'>
            <Vpagination
              data={props.playerBetHistoryData?.data}
              totalRecords={props.playerBetHistoryData?.totalRecords}
              paginationFirstValue={props.paginationFirstValue}
              paginationSecondValue={props.paginationSecondValue}
              setPaginationFirstValue={setPaginationFirstValue}
              setPaginationSecondValue={setPaginationSecondValue}
              recordsShow={props.recordsShow}
              setRecordsShow={setRecordsShow}
              isVisible={props.isVisible}
              setIsVisible={setIsvisible}
              csvData={csvData}
              exportPDF={exportPDF}
              callApi={callApi}
              csvFileName={"PlayerBetHistory"}
              payloadData={payload}
            />
            {!props.isVisible ? (
              <Skelton />
            ) : (
              <BettingHistoryTable data={props.playerBetHistoryData?.data} enableDownload pdfTitle="Player Bet Selections" fileName="player-bet-selections" />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

function mapStateToProps(state) {
  return {
    displayValue: state.sidebar.displayValue,
    userId: state.playersearch.userId,
    paginationFirstValue: state.playerBetHistorySlice.paginationFirstValue,
    paginationSecondValue: state.playerBetHistorySlice.paginationSecondValue,
    playerBetHistoryData: state.playerBetHistorySlice.playerBetHistoryData,
    userData: state.playerBetHistorySlice.userData,
    recordsShow: state.playerBetHistorySlice.recordsShow,
    isVisible: state.playerBetHistorySlice.isVisible,
    betStatusFilter: state.playerBetHistorySlice.betStatusFilter,
    betDecisionStatusFilter: state.playerBetHistorySlice.betDecisionStatusFilter,
    stakeTaxPermit: state.dashboard.stakeTaxPermission,
    winTaxPermit: state.dashboard.winTaxPermission,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    actions: bindActionCreators({}, dispatch),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(BettingHistory);
